(function(){
  /* ---- Config: change STORE_URL once your domain is connected ---- */
  var STORE_URL = '';

  /* Gallery: dots (mobile) + thumbnails (desktop), synced with swipe */
  var track = document.getElementById('cp-track');
  var slides = Array.prototype.slice.call(track.children);
  var dots = document.getElementById('cp-dots');
  var thumbs = document.getElementById('cp-thumbs');
  slides.forEach(function(s,i){
    var d = document.createElement('button');
    d.type='button'; d.setAttribute('aria-label','Image '+(i+1)+' of '+slides.length);
    d.addEventListener('click',function(){ go(i); });
    dots.appendChild(d);
    var t = document.createElement('button');
    t.type='button'; t.setAttribute('aria-label','Image '+(i+1)+' of '+slides.length);
    var im = s.querySelector('img');
    t.innerHTML = '<img src="'+im.getAttribute('src').replace('width=1400','width=400')+'" alt="" loading="lazy" width="160" height="160">';
    t.addEventListener('click',function(){ go(i); });
    thumbs.appendChild(t);
  });
  /* Desktop: one-row thumbnail strip with prev/next arrows */
  var chev = function(d){ return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+(d<0?'M15 5l-7 7 7 7':'M9 5l7 7-7 7')+'"/></svg>'; };
  var bar = document.createElement('div'); bar.className = 'cp-thumbbar';
  var prev = document.createElement('button'), next = document.createElement('button');
  prev.type = next.type = 'button'; prev.className = next.className = 'cp-tnav';
  prev.setAttribute('aria-label','Previous image'); next.setAttribute('aria-label','Next image');
  prev.innerHTML = chev(-1); next.innerHTML = chev(1);
  thumbs.parentNode.insertBefore(bar, thumbs);
  bar.appendChild(prev); bar.appendChild(thumbs); bar.appendChild(next);
  var want = null, wantT = 0;
  function base(){ return want !== null ? want : idx(); }
  prev.addEventListener('click',function(){ go(Math.max(0, base()-1)); });
  next.addEventListener('click',function(){ go(Math.min(slides.length-1, base()+1)); });
  function showThumb(i){
    var b = thumbs.children[i]; if(!b || !thumbs.offsetParent) return;
    var left = b.offsetLeft, right = left + b.offsetWidth, vl = thumbs.scrollLeft, vr = vl + thumbs.clientWidth;
    if(left < vl || right > vr) thumbs.scrollTo({left: left - (thumbs.clientWidth - b.offsetWidth)/2, behavior:'smooth'});
  }
  function idx(){ var best=0,d=1e9; slides.forEach(function(s,j){ var x=Math.abs(s.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft) - track.scrollLeft); if(x<d){d=x;best=j;} }); return best; }
  function pos(i){ return slides[i].offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft); }
  function go(i){
    want = i; clearTimeout(wantT);
    if(!('onscrollend' in window)) wantT = setTimeout(function(){ want = null; mark(); }, 1200);
    track.scrollTo({left: pos(i), behavior:'smooth'}); mark();
  }
  /* finish at the requested image even if rapid clicks interrupted the scroll */
  track.addEventListener('scrollend',function(){
    if(want === null) return;
    if(idx() === want){ want = null; mark(); } else { track.scrollTo({left: pos(want)}); }
  });
  ['pointerdown','touchstart','wheel'].forEach(function(ev){ track.addEventListener(ev,function(){ want = null; },{passive:true}); });
  function mark(){
    var i = base();
    [dots,thumbs].forEach(function(c){
      Array.prototype.forEach.call(c.children,function(b,j){ b.setAttribute('aria-current', j===i ? 'true':'false'); });
    });
    prev.disabled = i===0; next.disabled = i===slides.length-1;
    showThumb(i);
  }
  track.addEventListener('scroll',function(){ window.requestAnimationFrame(mark); },{passive:true});
  track.addEventListener('keydown',function(e){
    var i = idx();
    if(e.key==='ArrowRight'){ e.preventDefault(); go(Math.min(slides.length-1,i+1)); }
    if(e.key==='ArrowLeft'){ e.preventDefault(); go(Math.max(0,i-1)); }
  });
  mark();

  /* Bundle selector -> price, compare-at, saving, sticky bar */
  var price = document.getElementById('cp-price'), compare = document.getElementById('cp-compare'), save = document.getElementById('cp-save');
  var sName = document.getElementById('cp-stickyName'), sPrice = document.getElementById('cp-stickyPrice');
  var names = {'67759828631917':'1 Pack · 2 lights','67759828664685':'2 Pack · 4 lights','67759828697453':'3 Pack · 6 lights'};
  function money(n){ return '$'+Number(n).toFixed(2); }
  function selected(){ return document.querySelector('input[name="pack"]:checked'); }
  function update(){
    var r = selected(), p = r.dataset.price, c = r.dataset.compare;
    price.textContent = money(p); sPrice.textContent = money(p); sName.textContent = names[r.value];
    if(c){ compare.textContent = money(c); save.textContent = 'Save '+money(c - p); compare.hidden = false; save.hidden = false; }
    else { compare.hidden = true; save.hidden = true; }
  }
  document.getElementById('cp-bundles').addEventListener('change',update);
  update();
  /* Preselect a pack from ?variant= (links from the home page) */
  (function(){ var v = new URLSearchParams(location.search).get('variant'); if(!v) return; var r = document.querySelector('input[name="pack"][value="'+v+'"]'); if(r){ r.checked = true; update(); } })();

  /* ---------- Cart: real Shopify cart + drawer ----------
     1. POST /cart/add.js with the selected pack's variant ID
     2. GET /cart.js and render the drawer from Shopify's response only
     3. Checkout goes to /checkout */
  var VARIANTS = {            /* pack -> Shopify variant ID (checked against Admin) */
    '1 Pack': 67759828631917,
    '2 Pack': 67759828664685,
    '3 Pack': 67759828697453
  };
  var onShopify = !!(window.Shopify && window.Shopify.shop);

  /* drawer stylesheet sits next to this script in assets/ */
  (function(){
    var me = document.querySelector('script[src*="custom-pdp.js"]');
    if(!me) return;
    var l = document.createElement('link'); l.rel='stylesheet';
    l.href = me.src.replace('custom-pdp.js','custom-pdp-drawer.css');
    document.head.appendChild(l);
    var g = document.createElement('link'); g.rel='stylesheet';
    g.href = me.src.replace('custom-pdp.js','custom-pdp-gallery.css');
    document.head.appendChild(g);
  })();

  var root = document.querySelector('.cp-root') || document.body;
  var drawer = document.createElement('div');
  drawer.className = 'cp-drawer'; drawer.id = 'cp-drawer'; drawer.hidden = true;
  drawer.innerHTML =
    '<div class="cp-drawer-scrim" data-close></div>' +
    '<div class="cp-drawer-panel" role="dialog" aria-modal="true" aria-labelledby="cp-drawer-h">' +
      '<div class="cp-drawer-head"><h2 id="cp-drawer-h">Your cart</h2>' +
      '<button type="button" class="cp-drawer-x" data-close aria-label="Close cart">&times;</button></div>' +
      '<p class="cp-drawer-msg" id="cp-drawer-msg" role="status" aria-live="polite"></p>' +
      '<ul class="cp-drawer-items" id="cp-drawer-items"></ul>' +
      '<div class="cp-drawer-foot">' +
        '<div class="cp-drawer-sp" id="cp-drawer-sp"></div>' +
        '<div class="cp-drawer-sub"><span>Subtotal</span><b id="cp-drawer-total"></b></div>' +
        '<p class="cp-drawer-note">Shipping and taxes calculated at checkout.</p>' +
        '<button type="button" class="cp-cta" id="cp-checkout">Checkout</button>' +
      '</div>' +
    '</div>';
  root.appendChild(drawer);
  var dItems = drawer.querySelector('#cp-drawer-items'), dTotal = drawer.querySelector('#cp-drawer-total'),
      dMsg = drawer.querySelector('#cp-drawer-msg'), dCheckout = drawer.querySelector('#cp-checkout');
  var lastFocus = null;

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function fmt(cents, cur){
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:cur||'USD'}).format(cents/100); }
    catch(e){ return '$'+(cents/100).toFixed(2); }
  }
  function openDrawer(){
    lastFocus = document.activeElement; drawer.hidden = false;
    requestAnimationFrame(function(){ drawer.classList.add('cp-open'); });
    document.documentElement.style.overflow = 'hidden';
    drawer.querySelector('.cp-drawer-x').focus();
  }
  function closeDrawer(){
    drawer.classList.remove('cp-open'); document.documentElement.style.overflow = '';
    setTimeout(function(){ drawer.hidden = true; }, 200);
    if(lastFocus) lastFocus.focus();
  }
  drawer.addEventListener('click',function(e){ if(e.target.closest('[data-close]')) closeDrawer(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !drawer.hidden) closeDrawer(); });

  /* Render ONLY from the /cart.js response */
  function render(cart){
    window.cpLastCart = cart;
    var SP = window.UnholedSP, spId = SP ? SP.variantId : null;
    var items = cart.items.filter(function(it){ return Number(it.variant_id) !== spId; });
    var spLine = cart.items.filter(function(it){ return Number(it.variant_id) === spId; })[0];
    var spSlot = drawer.querySelector('#cp-drawer-sp');
    if(!items.length){
      dItems.innerHTML = '<li class="cp-drawer-empty">Your cart is empty.</li>';
      dTotal.textContent = fmt(0, cart.currency); dCheckout.disabled = true; spSlot.innerHTML = ''; return;
    }
    dCheckout.disabled = false;
    dItems.innerHTML = items.map(function(it){
      var img = it.image ? '<img src="'+esc(it.image)+(it.image.indexOf('?')>-1?'&':'?')+'width=160" alt="" width="64" height="64">' : '';
      img = '<div class="cp-line-img">'+img+'</div>';
      return '<li class="cp-line" data-key="'+esc(it.key)+'" data-variant="'+it.variant_id+'">' + img +
        '<div class="cp-line-info"><b>'+esc(it.product_title)+'</b>' +
        (it.variant_title ? '<span>'+esc(it.variant_title)+'</span>' : '') +
        '<span class="cp-line-qty">Qty '+it.quantity+' &middot; '+fmt(it.final_price, cart.currency)+' each</span>' +
        '<button type="button" class="cp-line-rm" data-remove="'+esc(it.key)+'">Remove</button></div>' +
        '<b class="cp-line-price" data-cents="'+it.final_line_price+'">'+fmt(it.final_line_price, cart.currency)+'</b></li>';
    }).join('');
    if(SP){
      spSlot.innerHTML = '<div class="sp-box">' + SP.boxHTML(!!spLine) + '</div>';
      spSlot.querySelector('.sp-check').addEventListener('change', function(e){
        var cb = e.target; cb.disabled = true; dMsg.textContent = '';
        SP.setEnabled(cb.checked).then(render).catch(function(){ cb.checked = !cb.checked; cb.disabled = false; dMsg.textContent = 'Couldn’t update shipping protection. Please try again.'; });
      });
    } else { spSlot.innerHTML = ''; }
    dTotal.textContent = fmt(cart.total_price, cart.currency);
    dTotal.setAttribute('data-cents', cart.total_price);
  }
  function getJSON(r){ return r.json().then(function(b){ if(!r.ok) throw b; return b; }); }
  function refresh(){ return fetch('/cart.js',{headers:{'Accept':'application/json'},cache:'no-store'}).then(getJSON).then(render); }

  dItems.addEventListener('click',function(e){
    var b = e.target.closest('[data-remove]'); if(!b) return;
    b.disabled = true; dMsg.textContent = '';
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:b.getAttribute('data-remove'),quantity:0})})
      .then(getJSON).then(refresh)
      .catch(function(err){ dMsg.textContent = (err && err.description) || 'Couldn’t update your cart. Please try again.'; b.disabled = false; });
  });
  dCheckout.addEventListener('click',function(){ window.location.href = '/checkout'; });

  function selectedVariant(){
    var r = selected();
    var pack = r.closest('label').querySelector('.cp-name').textContent.trim();
    return VARIANTS[pack] || Number(r.value);
  }
  var busy = false;
  function addToCart(e){
    e.preventDefault();
    var id = selectedVariant();
    if(!onShopify){ window.location.href = STORE_URL + '/cart/' + id + ':1'; return; }
    if(busy) return; busy = true;
    var btns = document.querySelectorAll('[data-cta]');
    Array.prototype.forEach.call(btns,function(b){ b.setAttribute('aria-disabled','true'); });
    dMsg.textContent = '';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(getJSON)
      .then(refresh)
      .then(openDrawer)
      .catch(function(err){
        dMsg.textContent = (err && (err.description || err.message)) || 'Couldn’t add to cart. Please try again.';
        return refresh().catch(function(){}).then(openDrawer);
      })
      .then(function(){ busy = false; Array.prototype.forEach.call(btns,function(b){ b.removeAttribute('aria-disabled'); }); });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-cta]'),function(a){ a.addEventListener('click',addToCart); });

  /* Sticky CTA shows after the main button leaves the screen */
  var sticky = document.getElementById('cp-sticky'), main = document.getElementById('cp-cta');
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(en){
      var gone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('cp-show',gone); sticky.setAttribute('aria-hidden', gone?'false':'true');
      sticky.querySelector('a').tabIndex = gone ? 0 : -1;
    }).observe(main);
  }
})();
